import React, { ReactElement, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router';
import { useSuccessMessageContext } from '../../../../context/SuccessMessageContext';
import { useClient, useClientStatusContext } from '../../../../context/ClientStatusContext';
import routes from '../../../../routing/routes';
import useFieldErrorMessages from '../../../useFieldErrorMessages';
import { updateTerminZaznamySekcie } from '../../../../client/termin/terminZaznamySekcieUpdateClient';
import ZaznamySekcieUpdateForm from './component/ZaznamySekcieUpdateForm';
import ZaznamSekcie from '../../../../model/ZaznamSekcie';
import { technickePricinyErrorStatus } from '../../../../constants/ErrorConstant';

interface Props {
  initialZaznamySekcie: Array<ZaznamSekcie>;
}

const ZaznamySekcieUpdate = ({ initialZaznamySekcie }: Props): ReactElement => {
  const [zaznamySekcie, setZaznamySekcie] = useState(initialZaznamySekcie);
  const { tezaurusUuid, terminUuid } = useParams<{ tezaurusUuid: string, terminUuid: string }>();

  const {
    wrapClient: terminZaznamSekcieUpdateClient,
    status: updateTerminStatus,
  } = useClient(updateTerminZaznamySekcie);

  const navigate = useNavigate();
  const { displaySuccess } = useSuccessMessageContext();
  const { handleStatus } = useClientStatusContext();
  const {
    getFieldErrorMessage,
    clearFieldErrorMessage,
    clearAllFieldErrorMessages,
  } = useFieldErrorMessages();

  const handleSubmit = async (event): Promise<void> => {
    event.preventDefault();
    await terminZaznamSekcieUpdateClient(terminUuid, zaznamySekcie);
    navigate(routes.tezaurus.admin.termin.detail.withParams(tezaurusUuid, terminUuid));
    displaySuccess('Vaša požiadavka bola úspešne vykonaná.');
  };

  useEffect(() => {
    if (updateTerminStatus?.responseCode === 404) {
      handleStatus(technickePricinyErrorStatus);
    }
  }, [updateTerminStatus, handleStatus]);

  return (
    <ZaznamySekcieUpdateForm
      zaznamySekcie={zaznamySekcie}
      setZaznamySekcie={setZaznamySekcie}
      onSubmit={handleSubmit}
      getFieldErrorMessage={getFieldErrorMessage}
      clearFieldErrorMessage={clearFieldErrorMessage}
      clearAllFieldErrorMessages={clearAllFieldErrorMessages}
      loading={updateTerminStatus.loading}
    />
  );
};

export default ZaznamySekcieUpdate;
